import mkMessages from '../locales/mk_MK.json';

const MkLang = {
  messages: {
    ...mkMessages,
  },
  locale: 'mk-MK',
};
export default MkLang;
